import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng: 'es',
      backend: {
        /* translation file path */
        loadPath: `${process.env.REACT_APP_BASE_URL || ''}/assets/i18n/{{ns}}/{{lng}}.json`
      },
      fallbackLng: 'es',
      debug: true,
      /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
      ns: ['trans'],
      defaultNS: 'trans',
      keySeparator: '.',
      interpolation: {
        escapeValue: false,
        formatSeparator: ','
      },
      react: {
        wait: true
      }
    });

export default i18n;
